type MenuItem = {
  id: number
  value: string
  name: string
}

export const MenuItemData: MenuItem[] = []
